import React from "react";
import { Clock } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PendingCartModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg max-w-md w-full mx-4">
        <div className="flex justify-center mb-4">
          <Clock size={64} weight="fill" className="text-yellow-500" />
        </div>
        <h2 className="text-2xl font-bold mb-4 text-center text-yellow-700">
          {t("modals.pendingCart.title")}
        </h2>
        <p className="text-gray-600 mb-6 text-center">
          {t("modals.pendingCart.message")}
        </p>
        <div className="flex flex-col gap-4">
          <Link
            to="/cart"
            className="bg-primary text-white py-2 px-4 rounded-md hover:bg-primary-dark transition-colors text-center"
          >
            {t("modals.pendingCart.viewCart")}
          </Link>
          <button
            onClick={onClose}
            className="border border-gray-300 py-2 px-4 rounded-md hover:bg-gray-100 transition-colors"
          >
            {t("modals.pendingCart.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingCartModal;
